<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">
          آپلود اکسل سطح مشتری‌ها
        </h5>
      </div>

      <div class="card-body">
        <Loading v-if="loading" />
        <b-form v-else @submit.prevent="submitHandler">
          <b-form-group label="انتخاب فایل اکسل">
            <b-form-file
              v-model="file"
              accept=".xlsx,.xls"
              placeholder="فایل اکسل را انتخاب کنید..."
              browse-text="انتخاب فایل"
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            :disabled="disabled || !file"
          >
            آپلود فایل
          </b-button>
        </b-form>
      </div>
    </div>
  </main>
</template>

<script>
import { BFormGroup, BFormFile, BButton, BForm } from "bootstrap-vue";

import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";

export default {
  name: "CustomerLevelsImport",

  components: {
    BFormGroup,
    BFormFile,
    BForm,
    BButton,
    Loading,
  },

  mixins: [mixins],

  data() {
    return {
      loading: false,
      disabled: false,
      file: null,
    };
  },

  methods: {
    async submitHandler() {
      if (!this.file) {
        this.$bvToast.toast("لطفا فایل اکسل را انتخاب کنید", {
          variant: "warning",
          solid: true,
        });

        return;
      }
      let formData = new FormData();

      formData.append("file", this.file);
      try {
        this.loading = true;
        this.disabled = true;
        const response = await this.$axios.post(
          "admin/customers/import-levels",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        this.$root.notify(response.data.message, "success");
        this.file = null;
      } catch (errors) {
        const message = errors.response?.data?.message;

        // this.$root.notify(message);
        this.$notify({
          group: "error",
          // title: "پیام سیستم",
          text: message,
          type: "error",
          duration: 15000,
        });
      } finally {
        this.loading = false;
        this.disabled = false;
      }
    },
  },
};
</script>

<style scoped>
.card-body {
  min-height: 200px;
}
</style>
